export function Welcome() {
  return (
    <section id="welcome" className="py-12 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-base sm:text-lg leading-relaxed text-gray-700 font-sans max-w-3xl mx-auto">
            Welcome to{' '}
            <strong className="text-gray-900 font-semibold">
              The Conservatory of Musical Arts Group
            </strong>
            , our vibrant music community near Haddonfield, NJ! We are a group of 
            passionate and talented musicians who have come together to create a unique 
            and inspiring experience for music enthusiasts of all ages. We provide a warm 
            and inviting atmosphere where creativity thrives, and students find their musical voices.
          </p>
        </div>
      </div>
    </section>
  );
}